export default {
    id: "transrussia-2026",
    articleType: "release",
    slug: "transrussia-2026-trendy-logistiki",
    date: "24 мая 2026",
    dateTime: "2026-05-24",
    modifiedTime: "2026-05-24",
    author: "Редакция «Светофор Логистика»",
    category: "События · 2026",
    contentType: "Событие",
    title: "TransRussia 2026: три тренда, которые меняют логистику",
    sidebarTitle: "Три тренда с TransRussia 2026",
    seoTitle:
        "TransRussia 2026: ЭПД, ИИ и логистика с Китаем | «Светофор Логистика»",
    seoDescription:
        "Итоги TransRussia 2026 от «Светофор Логистика»: переход на ЭПД, практическое применение ИИ и роботов, а также углубление логистической интеграции с Китаем.",
    image: "/img/news/transrussia-2026-trendy-logistiki/cover.webp",
    imageAlt: "Выставка TransRussia 2026",
    gallery: [
        {
            src:
                "/img/news/transrussia-2026-trendy-logistiki/photo-02.webp",

            thumbnail:
                "/img/news/transrussia-2026-trendy-logistiki/photo-02-thumb.webp",
            alt:
                "Встреча представителя «Светофор Логистика» на TransRussia 2026",
        },
        {
            src:
                "/img/news/transrussia-2026-trendy-logistiki/photo-03.webp",

            thumbnail:
                "/img/news/transrussia-2026-trendy-logistiki/photo-03-thumb.webp",
            alt: "Экспозиция транспортных технологий на TransRussia 2026",
        },
        {
            src:
                "/img/news/transrussia-2026-trendy-logistiki/photo-04.webp",

            thumbnail:
                "/img/news/transrussia-2026-trendy-logistiki/photo-04-thumb.webp",
            alt: "Деловая встреча на выставке TransRussia 2026",
        },
        {
            src:
                "/img/news/transrussia-2026-trendy-logistiki/photo-05.webp",

            thumbnail:
                "/img/news/transrussia-2026-trendy-logistiki/photo-05-thumb.webp",
            alt: "Модель железнодорожной цистерны на TransRussia 2026",
        },
        {
            src:
                "/img/news/transrussia-2026-trendy-logistiki/photo-06.webp",

            thumbnail:
                "/img/news/transrussia-2026-trendy-logistiki/photo-06-thumb.webp",
            alt:
                "Встреча участников международной логистической выставки TransRussia 2026",
        },
        {
            src:
                "/img/news/transrussia-2026-trendy-logistiki/photo-07.webp",

            thumbnail:
                "/img/news/transrussia-2026-trendy-logistiki/photo-07-thumb.webp",
            alt: "Деловая сессия на TransRussia 2026",
        },
        {
            src:
                "/img/news/transrussia-2026-trendy-logistiki/photo-08.webp",

            thumbnail:
                "/img/news/transrussia-2026-trendy-logistiki/photo-08-thumb.webp",
            alt: "Робот на стенде логистической компании на TransRussia 2026",
        },
        {
            src:
                "/img/news/transrussia-2026-trendy-logistiki/photo-09.webp",

            thumbnail:
                "/img/news/transrussia-2026-trendy-logistiki/photo-09-thumb.webp",
            alt: "Макеты контейнеров на международной логистической выставке",
        },
    ],
    content: {
        subtitle:
            "Итоги главной транспортно-логистической выставки и три направления, которые уже меняют отрасль",
        lead: [
            "Команда «Светофор Логистика» посетила ключевые сессии TransRussia 2026, пообщалась с участниками рынка и собрала основные сигналы, которые будут определять развитие логистики в ближайшее время.",
            "Главный вывод выставки: 2026 год становится годом ускоренной цифровизации отрасли.",
        ],
        sections: [
            {
                icon: "01",
                title: "Обратный отсчёт для ЭПД",
                paragraphs: [
                    "Одна из главных тем выставки — обязательный переход на электронные перевозочные документы с 1 сентября 2026 года. Экспериментальный этап завершается, а цифровое взаимодействие через государственные системы становится частью обязательной операционной модели.",
                    "Компаниям важно заранее настроить процессы и интеграции, чтобы переход не остановил перевозки и документооборот.",
                ],
            },
            {
                icon: "02",
                title: "ИИ и роботы: от экспериментов к практике",
                paragraphs: [
                    "Искусственный интеллект, роботизация складов, беспилотные технологии и автоматизация уже рассматриваются не как демонстрационные проекты, а как инструменты повышения производительности и снижения издержек.",
                    "На фоне дефицита персонала такие решения становятся одним из способов масштабировать операции без потери качества.",
                ],
            },
            {
                icon: "03",
                title: "Китай: более глубокая логистическая интеграция",
                paragraphs: [
                    "Сотрудничество России и Китая в логистике продолжает расширяться. На рынке появляются новые маршруты, инфраструктурные проекты, логистические хабы и железнодорожные продукты.",
                    "Это создаёт новые возможности для международных цепочек поставок и требует более тесной цифровой интеграции участников перевозки.",
                ],
            },
            {
                icon: "🚦",
                title: "Что делает «Светофор Логистика»",
                paragraphs: [
                    "Мы уже развиваем цифровые инструменты, которые помогают пользователям работать с электронными документами, автоматизировать процессы и управлять сложными логистическими цепочками в единой системе.",
                ],
            },
        ],
        galleryTitle: "TransRussia 2026",
    },
};
